export default {
  methods: {
    getMeterClasses (tableData, index) {
      return {
        'meter--first': tableData.length > 1 && index === 0,
        'meter--second': tableData.length > 2 && index === 1,
        'meter--last': (tableData.length === 2 && index === 1) || index === 2
      }
    },
    getInnerMeterClasses (tableData, index) {
      return {
        'meter-inner--first': tableData.length > 1 && index === 0,
        'meter-inner--second': tableData.length > 2 && index === 1,
        'meter-inner--last': (tableData.length === 2 && index === 1) || index === 2,
        'meter-inner--blue': index === 0,
        'meter-inner--green': index === 1,
        'meter-inner--pink': index === 2
      }
    },
    getTextClasses (tableData, index) {
      return {
        'meter-text--first': tableData.length > 1 && index === 0,
        'meter-text--second': tableData.length > 2 && index === 1,
        'meter-text--last': (tableData.length === 2 && index === 1) || index === 2,
        'meter-text--blue': index === 0,
        'meter-text--green': index === 1,
        'meter-text--pink': index === 2
      }
    },
    getFooterClasses (tableData, index) {
      return {
        'meter-text--first': tableData.length > 1 && index === 0,
        'meter-text--second': tableData.length > 2 && index === 1,
        'meter-text--last': (tableData.length === 2 && index === 1) || index === 2
      }
    }
  }
}
